import { Outlet } from 'react-router-dom'
import NavigationListener from '../../components/common/NavigationListner'

function ManageQueueLayoutConfig() {
  return (
    <div className="h-full">
      <NavigationListener />
      <Outlet />
    </div>
  )
}

export default ManageQueueLayoutConfig
